import React, { useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, List as ListComponent, useDrawer, Confirm } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext, useSettingContextInComponent } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';
import OperatorAssignation from '../externalbuttons/OperatorAssignation';
import OperatorAutoAssignation from '../externalbuttons/OperatorAutoAssignation';

const dataProviderName = 'campaigns/campaignlead';
const moduleName = "AudienceLeads";
const wizardAction = 'destroy';

const CampaignLeadList = (params) => {
	const { t } = useTranslation();
	const { userCapabilities, appConfiguration } = useContext(AppContext);
	const { filterModel } = useSettingContextInComponent(dataProviderName);
	const { activate } = useDrawer();
	const [importerVersion] = useState(appConfiguration.importer.version ?? null);

	const apiRef = useGridApiRef();
	const [selected, setSelected] = useState([]);
	const getSelected = () => [...apiRef.current.getSelectedRows()].map(([name]) => name);
	const handleRowSelection = (newSelection) => {
		setSelected(newSelection);
		params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
	};

	const [confirmDelete, setConfirmDelete] = useState();
	const handleDelete = () => {
		setConfirmDelete(
			<Confirm
				oklabel={t("Delete")}
				okcallable={async () => {
					doAction && await doAction({ action: wizardAction, model: dataProviderName, data: getSelected() });
					setConfirmDelete(null);
					apiRef.current.setRowSelectionModel([]);
					loadAll();
				}}
				kolabel={t("Cancel")}
				kocallable={() => { setConfirmDelete(null) }}
				title={t("Items elimination")}
			>
				{t("Are you sure to remove the selected elements?")}
			</Confirm>
		);
	};

	const { doAction, loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName);
	const [listFilterPageSort, setListFilterPageSort] = useState();
	const handleFilterPageSortChange = (model) => setListFilterPageSort(model);

	useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter });

	const handleRowDoubleclick = (row) => {
        if (params.relation?.drawerRouteActive) {
            activate(params.relation?.drawerRoute, { id: row.id });
        }
		// non vogliamo il click
	};

	const externalButtons = params?.relation?.externalButtons ?? [];
	const rightButtons = [];
	if (externalButtons.includes('operatorAssignationButton') && selected.length > 0) {
		rightButtons.push(<OperatorAssignation key="assign" selected={selected} campaignId={params?.relation?.campaignId} setSelected={setSelected} />);
	}
	if (externalButtons.includes('operatorAutoAssignationButton') && params?.relation?.campaignId) {
		rightButtons.push(<OperatorAutoAssignation key="autoAssign" campaignId={params?.relation?.campaignId} setSelected={setSelected} />);
	}

	return (
		<>
			{userCapabilities && userCapabilities[dataProviderName + '.list'] && (
				<ListComponent
					{...params}
					onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
					onFilterPageSortChange={handleFilterPageSortChange}
					items={items}
					total={total}
					loading={loading}
					apiRef={apiRef}
					enableSelection
					rightButtons={rightButtons}
					dataProviderName={dataProviderName}
					title={moduleName}
					rowSelectionExternalListener={handleRowSelection}
					doAction={doAction}
					filters={params.filters}
					columnsNeeded={[
						"_related_audienceLead_fullName",
						"_related_operator_fullName",
						"_related_operator_role",
						"_related_lastActivity_outcome_name",
						"_related_lastActivity_executed_at",
						"_related_audienceLead_cities",
						"_related_audienceLead_type",
						"_related_audienceLead_source",
						"_related_audienceLead_resCity",
						"_related_audienceLead_kam",
						"_related_audienceLead_privacyStatus",
					]}
					selectionModel={selected}
				/>
			)}
			{confirmDelete}
		</>
	);
};

export default CampaignLeadList;
